/* global unescape, angular, window, document */

angular.module('gc.share', ['gc.services'])
.service("ShareService", [
'$rootScope',
'$http',
'$filter',
'URL_SHORTENER',
function ($rootScope, $http, $filter, URL_SHORTENER) {
  'use strict';

  function addParam(url, param, value) {
    var a = document.createElement('a'), regex = /(?:\?|&amp;|&)+([^=]+)(?:=([^&]*))*/g;
    var match, str = []; a.href = url; param = encodeURIComponent(param);
    while (match = regex.exec(a.search))
      if (param != match[1]) str.push(match[1]+(match[2]?"="+match[2]:""));
    str.push(param+(value?"="+ encodeURIComponent(value):""));
    a.search = str.join("&");
    return a.href;
  }

  this.shortenUrl = function (url, commentId) {
   
    var a = document.createElement('a');
    a.href = url;

    // make yak.li links generation work locally
    if (url.indexOf('url=') === -1) {
      a.href = Utils.appendGetParam(a.href, 'url=%2F');
    }

    var params = a.search.match(/(?:[\?|&])([^=]+)=([^&]+)/g)
      .map(function (pattern) {
        return pattern.replace(/^\?|&/, '').split('=');
      })
      .reduce(function (memo, token) {
        memo[token[0]] = unescape(token[1]);
        return memo;
      }, {});

    var url = params.url;
    url = addParam(url, 'comment_id', commentId);
    url = addParam(url, 'scroll_top', '1');

    var req = {
      url: URL_SHORTENER,
      method: 'POST',
      data: { url },
      withCredentials: false
    };

    return $http(req).error(function(err) {
      console.error(err);
    });
  };

  /**
   * Opens a share window for the given provider.
   *
   * @param {String} network
   * @param {String} shortUrl
   */
  this.openShareWindow = function (network, shortUrl) {
    var url;

    if (network === 'fb') {
      url = 'http://www.facebook.com/sharer/sharer.php?u=' + shortUrl;
    }

    else if (network === 'twitter') {
      var profile = $rootScope.popinShare.profile;

      var trans = $filter('translate')('twitter share text', {
        url: shortUrl,
        content: 'CONTENT',
        by: profile && profile.twitter_username ? $filter('translate')('by', { user: profile.twitter_username }) : '',
      });

      function strip(html) {
        html = html.replace(/<br( \/)?>/gim, '\r\n');

        var tmp = document.createElement('div');
        $(tmp).html(html);
  
        return tmp.textContent || tmp.innerText || '';
      }

      var comment = $rootScope.popinShare.comment;
      var content = comment.content;
      if (comment.ecd) content = CommentService.ECD.getECDTitle(comment._id);
      else if (CommentService.title) content = CommentService.title;

      var comment = strip(content);
      var contentTruncated = $filter('truncate')(comment, 280 - (trans.length - 'CONTENT'.length));
      trans = trans.replace('CONTENT', contentTruncated);
      url = 'http://twitter.com/intent/tweet?text=' + encodeURIComponent(trans);
    }

    else if (network === 'linkedin') {
      url = 'https://www.linkedin.com/shareArticle?mini=true&url=' + shortUrl + '&source=LinkedIn' + shortUrl;
    }

    window.open(url, 'Share', 'width=700,height=700');
  };
}]);
